import Route from 'cio/routes/base';
import ActionsInAppController from './controller';
import Transition from '@ember/routing/-private/transition';

export default class InAppRoute extends Route {
  crumb() {
    return {
      name: 'In-App Messaging',
      path: 'actions.in_app',
    };
  }

  resetController(controller: ActionsInAppController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      // reset message id to clear query param and prevent reloading same message
      // when getting back to in-app settings page
      controller.messageId = '';
    }
  }
}
